import { AnimatePresence, motion } from 'framer-motion'
import { Check, ChevronDown } from 'lucide-react'
import clsx from 'clsx'

/** Progressive-disclosure wizard step. Locked steps show a dimmed header
 *  only; the active step is fully open; completed steps collapse to a
 *  one-line summary but can be re-expanded by clicking their header. */
export default function StepPanel({ n, title, state, summary, onReopen, children }) {
  // state: 'locked' | 'active' | 'done'
  const isOpen = state === 'active'
  return (
    <div className={clsx('border-b border-line last:border-0', state === 'locked' && 'opacity-40 pointer-events-none')}>
      <button
        onClick={() => state === 'done' && onReopen?.()}
        className="w-full flex items-center gap-3 py-4 text-left"
      >
        <span className={clsx(
          'w-6 h-6 rounded-full border flex items-center justify-center text-[11px] font-semibold shrink-0 transition-colors duration-200',
          state === 'done' ? 'bg-ok border-ok text-[#052]' : state === 'active' ? 'bg-blue border-blue text-[#04152e]' : 'border-line text-muted-2'
        )}>
          {state === 'done' ? <Check size={13} /> : n}
        </span>
        <span className="flex-1 text-[11px] font-semibold tracking-wider uppercase text-muted">{title}</span>
        {state === 'done' && (
          <>
            <span className="text-[12.5px] text-muted-2 truncate max-w-[220px]">{summary}</span>
            <ChevronDown size={15} className="text-muted-2" />
          </>
        )}
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.24, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <div className="pb-5">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
